import {  RangeObservable  } from './RangeObservable';

export const range = RangeObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/range.ts